module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing"
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "action": "."
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doSearch()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licenseplate),
      expression: "licenseplate"
    }],
    ref: "tester",
    staticClass: "hero-search animated fadeInUp delay-1s",
    attrs: {
      "type": "search",
      "placeholder": "AL 52 114",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.licenseplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.licenseplate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "animated fadeIn delay-2s",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                    Søg\n                ")])]), _vm._v(" "), (_vm.vehicles.length > 0) ? _c('div', {
    staticClass: "animated fadeIn delay-5s",
    on: {
      "click": function($event) {
        return _vm.goToRandomLicenseplate()
      }
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("eller")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "random-button"
  }, [_vm._v("\n                    Slå tilfældig nummerplade op\n                ")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-block animated fadeIn"
  }, [_c('h1', [_vm._v("\n                    Gratis nummerpladetjek\n                ")]), _vm._v("\n                Se bl.a. synsrapporter, restgæld, forsikring, afgifter mv.\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6743ed70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/landing.vue
// module id = 353
// module chunks = 1